import React from "react"

const Error = ({ error, onReload }) =>
    <div className="d-flex h-100 flex-column align-items-center w-100">
        <span className="my-2">{error}</span>
        <button onClick={onReload} className="my-1 reload-button shadow-none outline-none"><i className="la la-redo-alt"></i> Reload</button>
    </div>

export default Error
